<template>
  <div class="d-flex pa-2 video-container" no-gutters>
    <div class="justify-right d-flex pl-2">
      <div
        v-if="this.init"
        class="video-image d-flex justify-space-between align-end"
        :style="`background-image: url(${video.thumb_url}); position: relative;`"
      >
        <v-chip v-if="expiresAtLabel" color="#00000055" class="expires-badge white--text" x-small label>
          {{ expiresAtLabel }}
        </v-chip>
        <v-chip color="#00000055" class="mb-3 mr-1 white--text" small label>
        {{this.$helpers.lengthInMinutes(video.duration)}}
        </v-chip>
        <v-btn
            icon
            color="gray"
            class="mb-2 ml-1"
            @click="onPlayVideo()"
        >
          <v-icon size="20"  color="white">mdi-play</v-icon>
        </v-btn>
      </div>
      <video
        ref="video"
        class="video-image"
        v-bind:src="video.video_url"
        preload="none"
        controls
        :hidden="this.init"
        @click="onPlayVideo()"
      />
    </div>
    <v-flex class="d-flex flex-column">
      <span class="text-caption font-weight-bold">{{
        video.channel.name
      }}</span>
      <span class="text-caption video-title">{{ video.title }}</span>
      <span class="text-caption">צפיות: {{ video.views }}</span>
      <span v-if="video.publish_time" class="text-caption">תאריך {{ moment(video.publish_time).format("DD/MM/YYYY") }}</span>
      <div class="d-flex flex-row align-center justify-space-between">
        <v-menu
          v-model="showLockMenu"
          :close-on-content-click="false"
          offset-x
          v-if="!hideLockMenu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            icon
            color="black"
            v-bind="attrs"
            v-on="on">
              <font-awesome-layers full-width class="fa-2x">
                <font-awesome-icon
                  :icon="videoPosition.is_locked ? 'lock' : 'lock-open'"
                  :style="{ color: videoPosition.is_locked ? 'red' : 'black' }"
                />
                <font-awesome-layers-text
                  v-if="videoPosition.position"
                  :style="{ color: 'white' }"
                  :transform="
                    videoPosition.is_locked
                      ? 'down-3 shrink-10'
                      : 'left-3 down-3 shrink-10'
                  "
                  :value="videoPosition.position"
                />
              </font-awesome-layers>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item >
                <v-list-item-title class="text-subtitle-2">נעל מיקום</v-list-item-title>
                <v-list-item-action>
                  <v-text-field
                      type="number"
                      v-model="newPosition"
                      dense
                      class="input"
                      hide-details
                      no-gutters
                      single-line
                      outlined
                      @input="filterNumber"
                    />
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-card-actions>
              <v-btn
                text
                :disabled="!this.newPosition || this.newPosition < 0 || this.newPosition > 25"
                @click="onLockPosition()"
              >
                נעל
              </v-btn>
              <v-btn
                color="primary"
                text
                :disabled="!videoPosition.is_locked"
                @click="onUnlockPosition()"
              >
                שחרר נעילה
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-menu top offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="black" v-bind="attrs" v-on="on">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list min-width="200" flat>
            <v-list-item-group class="mx-2">
              <v-list-item dense class="underline px-0" @click="$emit('addVideoToSection', video)">
                <v-list-item-title>
                  <span class="text-subtitle-2"> הוסף לסקשן</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="videoPosition.is_locked"
                dense
                class="underline px-0"
                @click="$emit('removePosition', video)"
              >
                <v-list-item-title>
                  <span class="text-subtitle-2"> שחרר</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="!videoPosition.is_locked"
                dense
                class="underline px-0"
                @click.stop="showDeleteDlg = true"
              >
                <v-list-item-title>
                  <span class="text-subtitle-2 red--text"> הסר</span>
                </v-list-item-title>
              </v-list-item>
            </v-list-item-group>
            <v-list-item class="justify-end px-2">
              <v-btn text>סגור</v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-dialog v-model="showDeleteDlg" max-width="290">
            <v-card>
                <v-card-title class="text-subtitle-2" > האם אתה בטוח שברצונך להסיר וידאו זה מהפיד? </v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="showDeleteDlg = false">
                    חזור
                </v-btn>

                <v-btn color="green darken-1" text @click="onRemoveFeed()">
                    בסדר
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </div>
    </v-flex>
  </div>
</template>

<script>
import moment from "moment/moment";

export default {
  props: ["video","index","hideLockMenu"],
  data() {
    return {
        init: true,
        playing: false,
        newPosition: this.video.video_position ? this.video.video_position.position : null,
        showDeleteDlg: false,
        showLockMenu: false,
    };
  },
  computed: {
    videoElement() {
        return this.$refs.video;
    },
    activeVideoId() {
        return this.$store.getters.getActiveVideoId;
    },
    videoPosition() {
      return this.video.video_position || {
        id: null,
        position: null,
        is_locked: false
      }
    },
    expiresAt() {
      const pin = this.video.trending_manual_pin;
      const boost = this.video.trending_channel_boost;

      return (pin && pin.expires_at) || (boost && boost.expires_at) || null;
    },
    expiresAtLabel() {
      if (!this.expiresAt) return null;

      return moment(this.expiresAt).format('DD/MM HH:mm');
    }
  },
  watch: {
    activeVideoId: {
        handler: function(activeVideoId) {
            if (this.video.id !== activeVideoId) {
                this.playing = false;
                this.videoElement.pause()
            }
        }
    },
    video: {
      handler(video) {
        this.newPosition = video.video_position ? video.video_position.position : null
      },
      deep: true
    }
  },
  methods: {
    onPlayVideo() {
        this.init = false
        this.playing = !this.playing
        this.playing ? this.videoElement.play() : this.videoElement.pause()
        this.$store.dispatch("SET_ACTIVE_VIDEO_ID", this.video.id);
    },
    onRemoveFeed() {
        this.showDeleteDlg = false;
        this.$emit('removeFeed', this.video)
    },
    onLockPosition() {
      this.$emit('addPosition', this.video, this.newPosition);
      this.showLockMenu = false;
    },
    onUnlockPosition() {
      this.$emit('removePosition', this.video);
      this.showLockMenu = false;
    },
     filterNumber(e) {
       let val = e.target.value.replace(/\D/g, '')
       e.target.value = val
       this.newPosition = val
    },
  },
};
</script>

<style scoped>
.expires-badge {
  position: absolute;
  top: 8px;
  inset-inline-end: 8px;
  z-index: 1;
}
</style>

<style>
.input {
  border-radius: 0px;
}
</style>
